import {useState} from 'react';
import {useIntl} from 'react-intl';
import TabComponent from '../../../../app/common/components/TabComponent';
import Iperf from './Iperf';
import Qos from './Qos';
import {PageTitle} from '../../../../_metronic/layout/core';

const OutilsTest = (): JSX.Element => {
  const intl = useIntl();
  const [activeKey, setActiveKey] = useState<string>('iperf');

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'CONFIGURATION.INFO.OUTILS.TEST'})}
      </PageTitle>
      <TabComponent
        tabData={[
          {
            title: 'Iperf',
            key: 'iperf',
            to: '/configuration/routeurs-vpn/outilstest',
            content: <Iperf />,
          },
          {
            title: 'QOS',
            key: 'qos',
            to: '/configuration/routeurs-vpn/outilstest',
            content: <Qos />,
          },
        ]}
        activeKey={activeKey}
        onTabChange={setActiveKey}
      />
    </>
  );
};

export default OutilsTest;
